import {Routes} from '@angular/router';
import {CardListComponent} from "./card-list/card-list.component";
import {CardDetailsComponent} from "./card-details/card-details.component";
import {HomeComponent} from "./home/home.component";

export const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'card-list', component: CardListComponent},
  {path: 'dpk-details/:id', component: CardDetailsComponent}
];
